const frontendURL = '/cat/house/';
const backendURL = '/api/references/house/';
const name = 'Будинки';

const instance = {
  frontendURL,
  backendURL,
  name,
  useHierarchyPagination: true,
};
export default instance;
